import Founder from './Founder'

export default Founder
